/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit BooleanInput/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import SimpleMissingView from 'Simple/MissingView'

function TysiaCheckboxLabel() {
  return (
    <SimpleMissingView
      pointOfUseViewId="BooleanInput"
      pointOfUseFile="/home/circleci/project/apps/admin/src/DesignSystem/AppsLauncherProperties/Content/ActiveStep/None/BooleanInput/view.blocks"
      targetViewId="TysiaCheckboxLabel"
      targetFileAtPointOfUse="/home/circleci/project/apps/admin/src/DesignSystem/AppsLauncherProperties/Content/ActiveStep/None/BooleanInput/TysiaCheckboxLabel/view.blocks"
      targetFileAtDesignSystem="/home/circleci/project/apps/admin/src/DesignSystem/TysiaCheckboxLabel/view.blocks"
    />
  )
}
import TysiaCheckbox from 'DesignSystem/TysiaCheckbox/index'



/** @type {import('Simple/types.js').View} */
export default function BooleanInput({
  children,
  viewPath = "/DesignSystem/AppsLauncherProperties/Content/ActiveStep/None/BooleanInput",
  onChange,
  isSubmitting
  
}) {
let selectedValueValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'value',
})
let selectedValueChangeData = fromData.useDataChange({ viewPath,
context: 'selected',
path: 'value',
})
let stepsIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'steps',
})
let selectedNameValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'name',
})
  return (<React.Fragment
>
<TysiaCheckbox
  viewPath={`${viewPath}/TysiaCheckbox`}
 data="selected.value"
 value={selectedValueValueData}
 onChange={selectedValueChangeData}
 data="steps"
 disabled={stepsIsSubmittingData}
>
{childProps => (
<TysiaCheckboxLabel
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxLabel`}
 data="selected.name"
 text={selectedNameValueData}
/>
)}
</TysiaCheckbox>
{children}
</React.Fragment>)
}